import { render, staticRenderFns } from "./LogoOnFabricSection.vue?vue&type=template&id=25bfa45c"
import script from "./LogoOnFabricSection.vue?vue&type=script&lang=ts"
export * from "./LogoOnFabricSection.vue?vue&type=script&lang=ts"
import style0 from "./LogoOnFabricSection.vue?vue&type=style&index=0&id=25bfa45c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports